import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";

import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Breadcrumb, Footer, Header, Sidebar } from "../../components";
import BaseURL from "../../assets/utils/baseUrl";

function DokumenPerencanaan() {
  useDocumentTitle("Dokumen Perencanaan - BAPENDA BEKASI");

  const [laporan, setLaporan] = useState([]);

  useEffect(() => {
    fetch(BaseURL + "index.php/api/Dokumen_perencanaan")
      .then((res) => res.json())
      .then((data) => {
        if (data.data) {
          let tableData = [];
          for (let i = 0; i < data.data.length; i++) {
            tableData.push({
              judul: data.data[i].judul,
              deskripsi: data.data[i].deskripsi,
              link: data.data[i].link,
            });
          }
          setLaporan(tableData);
        }
      })
      .catch((error) =>
        console.log("sorry, there is a mistake while loading data")
      );
  }, []);

  const columns = [
    {
      name: "judul",
      label: "Deskripsi",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return <div style={{ flex: 1 }}>{value}</div>;
        },
      },
    },
    {
      name: "deskripsi",
      label: "Alamat Unit",
      options: {
        filter: true,
        sort: true,
      },
      customBodyRender: (value) => {
        return <div style={{ flex: 1 }}>{value}</div>;
      },
    },
    {
      name: "link",
      label: "Link",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return (
            <div style={{ flex: 1 }}>
              <a href={value} target="_blank" rel="noopener noreferrer">
                {value}
              </a>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    sort: true,
    filter: false,
    download: false,
    print: false,
    selectableRows: false,
  };

  return (
    <div className="page">
      <Header active="publikasi" />

      {/* main */}
      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Publikasi / Dokumen Perencanaan" />
          <div className="page-title-wrapper">
            <div className="page-title">Dokumen Perencanaan</div>
          </div>

          <MUIDataTable
            title={"Daftar dokumen"}
            data={laporan}
            columns={columns}
            options={options}
            download={false}
            className="table"
          />
        </section>
        <Sidebar />
      </main>

      <Footer />
    </div>
  );
}

export default DokumenPerencanaan;
